import React from 'react';
import styled, { ThemeContext } from 'styled-components';

const LinkedInLink = styled.div`
  margin: 23px 0;

  div {
    height: 40px;
    width: 215px;
    background: url(${props => props.theme.linkedInLogo});
    background-size: 215px 120px;
    background-position: 0px -40px;
  }

  &:hover {
    background-position: 0px -80px;
  }

  &:active {
    background-position: 0px 0px;
  }
`;

export default function LinkedInButton() {
  const { linkedInAuthorizeUrl } = React.useContext(ThemeContext);

  return (
    <LinkedInLink>
      <a href={linkedInAuthorizeUrl}>
        <div />
      </a>
    </LinkedInLink>
  );
}
